/**
 * QuestionListItem
 */
import React from 'react';
import { Icon } from 'ui-component-library/base';
/** Naviagation list with links. */
var QuestionListItem = function (_a) {
    var _b = _a.url, url = _b === void 0 ? '#' : _b, heading = _a.heading;
    return (React.createElement("div", { className: "relative pb-6 mb-6 border-b-2 questionlist__item border-greyLight", "data-cid": "QuestionListItem" },
        React.createElement("h3", { className: "font-semibold text-h3" },
            React.createElement("a", { href: url, className: "flex justify-between no-underline hover:underline group" },
                React.createElement("span", { className: "flex text-black questionlist__header-wrapper" },
                    React.createElement("span", { className: "w-8 h-8 mr-4" },
                        React.createElement(Icon, { icon: "question", "aria-hidden": "true", className: "text-purple", size: 3 })),
                    heading)))));
};
export default QuestionListItem;
